module.exports = __webpack_public_path__ + "static/media/Gucci-Black-Dionysus-Medium-Leather-Shoulder-Bag-Lyst.1cacc2f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/bags/Gucci-Black-Dionysus-Medium-Leather-Shoulder-Bag-Lyst.png
// module id = 215
// module chunks = 0